import * as React from 'react'
import { IconPropsType } from '../types'

const FollowWhatsappIcon = (props: IconPropsType) => {
   const { height = 28, width = 28, fill = '#fff' } = props
   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width ?? 28}
         height={height ?? 28}
         fill='none'
         viewBox='0 0 28 28'
         {...props}
      >
         <rect width={29} height={28} fill='#1A1B1E' rx={6} />
         <path
            fill={fill ?? '#fff'}
            d='M14.58 6c-4.57 0-8.274 3.675-8.274 8.21 0 1.55.434 3.001 1.187 4.239L6 22.853l4.58-1.455a8.291 8.291 0 0 0 4 1.021c4.57 0 8.273-3.676 8.273-8.21C22.853 9.676 19.15 6 14.58 6Zm4.114 11.327c-.195.483-1.075.923-1.464.944-.388.02-.399.3-2.514-.619-2.115-.919-3.388-3.154-3.488-3.298-.1-.143-.82-1.168-.78-2.199.038-1.03.603-1.518.804-1.72a.81.81 0 0 1 .573-.241c.167-.003.275-.005.398 0 .123.004.308-.026.468.4.16.426.544 1.473.593 1.58.049.106.08.23.004.367-.076.137-.115.223-.225.342-.11.118-.232.265-.33.355-.11.1-.225.21-.11.424.116.214.514.916 1.12 1.495.78.744 1.453.99 1.66 1.103.207.113.331.1.46-.035.128-.136.55-.593.7-.797.148-.204.288-.164.479-.087.19.077 1.21.623 1.417.735.207.113.346.17.395.26.05.09.034.509-.16.991Z'
         />
      </svg>
   )
}

export default FollowWhatsappIcon
